import Swiper, { Autoplay, Navigation } from 'swiper';
import Sharer from 'sharer.js/sharer';
// import { Navigation, Pagination } from 'swiper/modules';


export default {
    when() {
        return document.querySelectorAll(".section-gallery").length > 0;
    },

    mounted() {
        if (document.querySelectorAll('.section-gallery').length > 0) {
            let swipers = [];
            let isOpen = false;

            let allPage = document.querySelector('body');
            let sections = document.querySelectorAll('.section-gallery');
            window.Sharer.init()
            sections.forEach((section, indexSection) => {
                // The carousel in the modal

                let idImageChoice = 0;
                let shareLinks = section.querySelectorAll('.share-link-component button');
                let allImages = section.querySelector('.all-images-event-gallery');
                let allImagesArray = Array.from(allImages.children);
                let allDownloadIcons = section.querySelectorAll('.download-gallery-icon')
                // THE MODAL
                let closeButton = section.querySelector('.close-modal-event-gallery-button');
                let closeButtonBack = section.querySelectorAll('.close-modal-back-gallery-button');
                let modal = section.querySelector('.modal-gallery');
                let insideModal = section.querySelector('.inside-modal-gallery');
            

                swipers.push(new Swiper(section.querySelector('.mySwiper'), {
                    modules: [Navigation],
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    centeredSlides: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 90,
                        },
                    },
                }));

            
                section.addEventListener(
                    'click',
                    (event) => {
                        if (isOpen == false) {
                            swipers[indexSection].on('slideChange', function () {
                                history.replaceState('', document.title, `${window.location.origin}${window.location.pathname}?image=${swipers[indexSection].realIndex}&slide=${indexSection}`);
                                if (shareLinks.length > 0) {
                                    shareLinks.forEach(link => {
                                        link.setAttribute("data-url", `${window.location.origin}${window.location.pathname}?image=${swipers[indexSection].realIndex}&slide=${indexSection}`);
                                    })
                                }
                            });

                            allImagesArray.forEach((button) => {
                                let icon = null;
                                if (button.querySelectorAll('.download-gallery-icon').length > 0) {
                                    icon = button.querySelector('.download-gallery-icon')
                                }
                                if (event.composedPath().includes(button) && !event.composedPath().includes(icon)) {
                                    idImageChoice = parseInt(button.dataset.id);
                                    modal.classList.add('flex');
                                    modal.classList.remove('hidden');
                                    allPage.classList.add('overflow-hidden');

                                    isOpen = true;

                                    swipers[indexSection].slideToLoop(idImageChoice, 0, true)
                                    history.replaceState('', document.title, `${window.location.origin}${window.location.pathname}?image=${idImageChoice}&slide=${indexSection}`);
                                }
                            });

                        } else {
                            let withinBoundaries = event.composedPath().includes(insideModal);
                            let isCloseButton = event.composedPath().includes(closeButton);
                            let isCloseButtonBack = false;
                            closeButtonBack.forEach(button => {
                                if (event.composedPath().includes(button)) {
                                    isCloseButtonBack = true;
                                }
                            })


                            if (withinBoundaries == false || isCloseButton == true || isCloseButtonBack == true) {
                                modal.classList.add('hidden');
                                modal.classList.remove('flex');
                                allPage.classList.remove('overflow-hidden');
                                isOpen = false;
                                history.replaceState('', document.title, window.location.origin + window.location.pathname);
                            }
                        }
                    },
                    { passive: true }
                );
            })
            
            
            if (window.location.search) {
                const urlParams = new URLSearchParams(window.location.search);
                let idImage = urlParams.get('image')
                let idSlide = urlParams.get('slide')
                sections[idSlide].querySelectorAll('[data-id]').forEach(dataId => {
                    if (dataId.dataset.id == idImage) {
                        sections[idSlide].querySelector('.modal-gallery').classList.add('flex');
                        sections[idSlide].querySelector('.modal-gallery').classList.remove('hidden');
                        allPage.classList.add('overflow-hidden');
                        isOpen = true;
                        let shareLinks2 = sections[idSlide].querySelectorAll('.share-link-component button');
                        swipers[idSlide].slideToLoop(idImage, 0, true)
                        swipers[idSlide].on('slideChange', function () {
                            history.replaceState('', document.title, `${window.location.origin}${window.location.pathname}?image=${swipers[idSlide].realIndex}&slide=${idSlide}`);
                            if (shareLinks2.length > 0) {
                                shareLinks2.forEach(link => {
                                    link.setAttribute("data-url", `${window.location.origin}${window.location.pathname}?image=${swipers[idSlide].realIndex}&slide=${idSlide}`);
                                })
                            }
                        });

                    }
                })

            }
        }
    }
}